<div class="jumbotron bg-white">
    <div class="container">
        <div class="row">
            <div class="col-md-8 offset-md-3">

<form [formGroup]="lunchForm" class="text-center border border-light p-5">

    <p class="h4 mb-4" translate>Lunch Assignment</p>

    <!--{{lunchForm.value | json}}-->
    <div class="row pl-3 form-group ">
           
        <label class="float-left font-weight-bold" translate>Sales Representative</label>
        <select class=" form-control select2 select2-hidden-accessible"
            formControlName="salesRep" id="salesRep" name="salesRep"
             tabindex="-1" aria-hidden="true"
            [class.is-invalid]="formErrors.salesRep"
            (blur)="logValidationErrors(lunchForm)"  >
            <option value=""  disabled selected>Select</option>
            <option data-tagprefix=''*ngFor='let rep of salesRepList' value={{rep.userID}}>{{rep.fullName}}</option>
                </select>        
    </div>

    <label class="text-left font-weight-bold p-2 rounded w-100" translate>Lunch Time</label>
    <app-date-time-picker  formControlName="lunchTime"  name="lunchTime"></app-date-time-picker>   
    
    

  
    <button class="btn btn-dark my-4 btn-block" *ngIf="submitbutton" (click)='assignLunch();' style="cursor: pointer;" type="submit" translate>Submit</button>
    <button class="btn btn-dark my-4 btn-block" *ngIf="updatebutton" (click)='assignLunch();' style="cursor: pointer;"  translate>Update</button>
    <button class="btn btn-dark my-4 btn-block" *ngIf="updatebutton" (click)='deleteLunch();' style="cursor: pointer;" translate>Delete</button>


    <hr>

</form>

</div>
</div>
</div>
</div>


<!----------------------------------------------------------------------------------------------------------------------------------------------------------------
      Success Modal
------------------------------------------------------------------------------------------------------------------------------------------------------------------->  
<button id="openSuccessModalButton" [hidden]="true" data-toggle="modal" data-target="#SuccessModal">Open Modal</button>
<!-- Modal -->
<div id="SuccessModal" class="modal fade" role="dialog">
    <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
            <div class="modal-header">

                <h4 class="modal-title text-success" translate>SUCCESS</h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body text-success">
                <p translate>Lunch assignment has been created.</p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default" (click)="backClicked()"
                    data-dismiss="modal">Close</button>
            </div>
        </div>

    </div>
</div>

<!-------------------------------------------------------------------------------------------------------------------------------------------------------------------
        Error Modal
------------------------------------------------------------------------------------------------------------------------------------------------------------------->        
<button id="openErrorModalButton" [hidden]="true" data-toggle="modal" data-target="#ErrorModal">Open Modal</button>
<!-- Modal -->
<div id="ErrorModal" class="modal fade" role="dialog">
    <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
            <div class="modal-header">

                <h4 class="modal-title text-danger" translate>ERROR</h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body text-danger">
                <p>{{error}}</p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default" (click)="backClicked()"
                    data-dismiss="modal" translate>Close</button>
            </div>
        </div>

    </div>
</div>

<!----------------------------------------------------------------------------------------------------------------------------------------------------------------
      Success Delete Modal
------------------------------------------------------------------------------------------------------------------------------------------------------------------->      

<button id="openSuccessDeleteModalButton" [hidden]="true" data-toggle="modal" data-target="#SuccessDeleteModal">Open Modal</button>
<!-- Modal -->
<div id="SuccessDeleteModal" class="modal fade" role="dialog">
    <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
            <div class="modal-header">

                <h4 class="modal-title text-success" translate>SUCCESS</h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body text-success">
                <p translate>Lunch assignment has been deleted.</p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default" (click)="backClicked()"
                    data-dismiss="modal" translate>Close</button>
            </div>
        </div>

    </div>
</div>

<!-------------------------------------------------------------------------------------------------------------------------------------------------------------------
        Error Delete Modal
------------------------------------------------------------------------------------------------------------------------------------------------------------------->
<button id="openErrorDeleteModalButton" [hidden]="true" data-toggle="modal" data-target="#ErrorDeleteModal">Open Modal</button>
<!-- Modal -->
<div id="ErrorDeleteModal" class="modal fade" role="dialog">
    <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
            <div class="modal-header">

                <h4 class="modal-title text-danger" translate>ERROR</h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body text-danger">
                <p>{{error}}</p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default" (click)="backClicked()"
                    data-dismiss="modal" translate>Close</button>
            </div>
        </div>

    </div>
</div>